import Select from "react-select";
import { compactSelectStyles } from "../../../utils/reactSelectControlStyles.js";
import styles from "../../../styles/Reports.module.css";
import ReportFilterSection from "./ReportFilterSection.jsx";
import ReportYearSelect from "./ReportYearSelect.jsx";

const InvoiceReportPanel = ({
  t,
  reportI18nKeys,
  yearOptions,
  selectedYear,
  selectedReportOption,
  allEventsOptions,
  selectedEvent,
  loadingEvents,
  billed,
  onSelectEvent,
  businessEventSelectProps,
  handlers,
}) => {
  const { onYearOptionChange, onToggleBilled } = handlers;

  return (
  <ReportFilterSection t={t} reportI18nKeys={reportI18nKeys}>
    <ReportYearSelect
      t={t}
      reportI18nKeys={reportI18nKeys}
      yearOptions={yearOptions}
      selectedYear={selectedYear}
      onYearOptionChange={onYearOptionChange}
      isDisabled={!selectedReportOption}
    />
    <div className={styles.filterItemContent}>
      <label className={styles.label}>{t(reportI18nKeys.EVENT)}</label>
      <Select
        options={allEventsOptions}
        value={selectedEvent}
        onChange={onSelectEvent}
        isClearable
        isDisabled={!selectedReportOption}
        isLoading={loadingEvents}
        placeholder={t(reportI18nKeys.EVENT_PLACEHOLDER)}
        styles={compactSelectStyles}
        {...businessEventSelectProps}
      />
    </div>
    <div className={styles.filterItemContent}>
      <div className={styles.checkboxItem}>
        <input
          type="checkbox"
          id="includeBilled"
          className={styles.checkbox}
          checked={billed}
          onChange={onToggleBilled}
        />
        <label htmlFor="includeBilled" className={styles.checkboxLabel}>
          {t("pages.reports.includeBilled")}
        </label>
      </div>
    </div>
  </ReportFilterSection>
  );
};

export default InvoiceReportPanel;
